<div class="flex h-full flex-col gap-2 overflow-auto py-4">
  <div class="grid grid-cols-3 gap-2">
    <sia-select-box
      label="Template quando"
      [(value)]="gridConfiguration.showTemplate"
      [selectBoxOptions]="{
        value: gridConfiguration.showTemplate,
        fixedDataSource: showTemplateSelectionTypes,
      }"
    >
    </sia-select-box>
    <sia-check-box
      label="Abilita switch tra griglia e template"
      [(value)]="gridConfiguration.switchView"
    ></sia-check-box>
    <sia-number-box
      label="Dimensione pagina"
      [(value)]="gridConfiguration.pageSize"
    ></sia-number-box>
    <sia-check-box
      label="Abilita riga filtri"
      [(value)]="gridConfiguration.filterRowEnabled"
    >
    </sia-check-box>
    <sia-check-box
      label="Abilita ricerca globale"
      [(value)]="gridConfiguration.globalFilterEnabled"
    >
    </sia-check-box>
  </div>
  <div class="grid grid-cols-3 gap-2">
    <sia-check-box
      class="flex-1"
      label="Abilita selettore colonne"
      [(value)]="gridConfiguration.actionColumnChooserEnabled"
    ></sia-check-box>
    <sia-check-box
      class="flex-1"
      label="Mostra bordi"
      [(value)]="gridConfiguration.showBorders"
    ></sia-check-box>
    <sia-check-box
      class="flex-1"
      label="Mostra bordi Template"
      [(value)]="gridConfiguration.showTemplateBorders"
    ></sia-check-box>
    <sia-check-box
      class="flex-1"
      label="Righe alternate"
      [(value)]="gridConfiguration.rowAlternationEnabled"
    ></sia-check-box>
  </div>
  <div class="grid grid-cols-3 gap-2">
    @if (gridConfiguration.group?.useCustomDatafield) {
      <sia-text-box
        class="flex-1"
        label="Raggruppa per"
        [(value)]="gridConfiguration.group!.groupDataField"
      ></sia-text-box>
    } @else {
      <sia-select-box
        label="Raggruppa per"
        [(value)]="gridConfiguration.group!.groupDataField"
        [selectBoxOptions]="{
          fixedDataSource: databaseFields(),
          disableEmptyElement: true,
          value: gridConfiguration.group!.groupDataField,
        }"
      ></sia-select-box>
    }
    <sia-text-box
      class="flex--2"
      label="Testo raggruppamento"
      [(value)]="gridConfiguration.group!.groupText"
    ></sia-text-box>
    <sia-text-box
      class="flex-1"
      label="Campo testo raggruppamento"
      [(value)]="gridConfiguration.group!.groupNameDataField"
    ></sia-text-box>
  </div>
  @if (gridConfiguration.group?.groupDataField) {
    <sia-accordion
      title="Sottogruppi"
      [opened]="false"
      style="width: 100%; margin-bottom: 8px"
    >
      <div class="flex flex-col gap-2">
        <button mat-button (click)="addSubGroup()" class="w-full">
          <mat-icon>add</mat-icon> {{ 'Aggiungi sottogruppo' | siaTranslate }}
        </button>

        @for (
          group of gridConfiguration.subGroups;
          track group;
          let indexGroup = $index
        ) {
          <div class="grid grid-cols-3 gap-2">
            <sia-text-box
              class="flex-1"
              label="Raggruppa per"
              [(value)]="group.groupDataField"
            ></sia-text-box>
            <sia-text-box
              class="flex--2"
              label="Testo raggruppamento"
              [(value)]="group.groupText"
            ></sia-text-box>
            <sia-text-box
              class="flex-1"
              label="Campo testo raggruppamento"
              [(value)]="group.groupNameDataField"
            ></sia-text-box>
          </div>
          <button
            mat-stroked-button
            (click)="removeSubGroup(indexGroup)"
            class="error m-auto"
          >
            <mat-icon>delete</mat-icon> {{ 'Elimina' | siaTranslate }}
          </button>
        }
      </div>
    </sia-accordion>
  }
  <sia-accordion
    title="Azioni gruppo"
    [opened]="false"
    style="width: 100%; margin-bottom: 8px"
  >
    <div class="flex flex-col gap-2">
      <button mat-button (click)="addGroupAction()" class="w-full">
        <mat-icon>add</mat-icon> {{ 'Aggiungi azione' | siaTranslate }}
      </button>

      @for (
        action of gridConfiguration.group?.groupActions;
        track action;
        let index = $index
      ) {
        <div class="surface-low flex flex-col gap-2 rounded-lg p-2">
          <div class="grid grid-cols-2 gap-2">
            <sia-text-box
              class="flex-1"
              label="Icona azione"
              [(value)]="action.icon"
            ></sia-text-box>
            <sia-text-box
              class="flex-1"
              label="Tooltip azione"
              [(value)]="action.tooltip"
            ></sia-text-box>
          </div>
          <div class="w-full">
            <sia-js-editor
              [(jsCode)]="action.script"
              [title]="'Script azione gruppo'"
            ></sia-js-editor>
          </div>
          <button
            mat-stroked-button
            (click)="removeGroupAction(index)"
            class="error m-auto"
          >
            <mat-icon>delete</mat-icon> {{ 'Elimina' | siaTranslate }}
          </button>
        </div>
      }
    </div>
  </sia-accordion>
  <div class="grid grid-cols-3 gap-2">
    <sia-check-box
      class="flex-1"
      label="Disabilita esportazione"
      [(value)]="gridConfiguration.exportDisabled"
    ></sia-check-box>
    <sia-text-box
      class="flex-1"
      label="Nome file esportazione"
      [(value)]="gridConfiguration.exportFileName"
      [disabled]="!gridConfiguration.exportDisabled"
    ></sia-text-box>
    <sia-number-box
      class="flex-1"
      label="Ricarica ogni(secondi)"
      [(value)]="gridConfiguration.keepLoadingInterval"
    ></sia-number-box>
  </div>

  <div class="grid grid-cols-3 gap-2">
    <sia-check-box
      class="flex-1"
      label="Editing in riga"
      [(value)]="gridConfiguration.rowEditingEnabled"
    ></sia-check-box>
    <sia-check-box
      class="flex-1"
      label="Aggiornamento massivo"
      [(value)]="gridConfiguration.allowMassiveUpdate"
    >
    </sia-check-box>
    <sia-check-box
      class="flex-1"
      label="Eliminazione massiva"
      [(value)]="gridConfiguration.allowMassiveDelete"
    ></sia-check-box>
    <sia-text-box
      label="SP Eliminazione"
      [disabled]="!gridConfiguration.allowMassiveDelete"
      [(value)]="gridConfiguration.massiveDeleteSPName"
      class="flex-1"
    >
    </sia-text-box>
    <sia-text-box
      label="SP Select"
      [(value)]="gridConfiguration.selectSpName"
      class="flex-1"
    >
    </sia-text-box>
  </div>
  <sia-select-box
    [(value)]="gridConfiguration.addingType"
    label="Aggiunta"
    [selectBoxOptions]="{
      value: gridConfiguration.addingType,
      fixedDataSource: gridConfAddingTypes,
    }"
  ></sia-select-box>
  <div class="w-full">
    @if (gridConfiguration.addingType == 'script') {
      <sia-js-editor
        [(jsCode)]="gridConfiguration.addingActionScript"
        [title]="'Script aggiunta'"
      ></sia-js-editor>
    }
  </div>
  @if (gridConfiguration.addingType == 'choice') {
    <sia-accordion title="Scelte" [opened]="true" style="width: 100%">
      <div class="flex flex-row flex-wrap gap-2">
        <sia-text-box
          [(value)]="gridConfiguration.addingChoisesTitle"
          label="Titolo"
          class="w-[calc(50%-0.5rem)]"
        ></sia-text-box>
        <sia-text-box
          [(value)]="gridConfiguration.addingChoicesDescription"
          class="w-[calc(50%-0.5rem)]"
          label="Descrizione"
        ></sia-text-box>
        <button mat-button (click)="addChoice()" class="w-full">
          <mat-icon>add</mat-icon> {{ 'Aggiungi scelta' | siaTranslate }}
        </button>
        @for (
          choice of gridConfiguration.addingChoisesItems;
          track choice;
          let index = $index
        ) {
          <div
            class="surface-low flex w-full flex-row flex-wrap justify-center rounded-lg p-2"
          >
            <sia-text-box
              label="Testo"
              [(value)]="choice.name"
              class="w-1/2"
            ></sia-text-box>
            <sia-text-box
              label="Icona"
              [(value)]="choice.icon"
              class="w-1/2"
            ></sia-text-box>
            <sia-js-editor
              [(jsCode)]="choice.navigationScript"
              [title]="'Script pulsante'"
              class="w-full"
            ></sia-js-editor>
            <button
              mat-stroked-button
              (click)="removeChoice(index)"
              class="error m-auto"
            >
              <mat-icon>delete</mat-icon> {{ 'Elimina' | siaTranslate }}
            </button>
          </div>
        }
      </div>
    </sia-accordion>
  }

  <sia-accordion title="Parametri Store Procedure" [opened]="false">
    <div
      class="md:surface-lowest flex h-full w-full flex-col content-center rounded-lg md:p-4"
    >
      <div class="flex flex-col gap-2">
        <button mat-button (click)="addSpParams()" class="w-full">
          <mat-icon>add</mat-icon>
          {{ 'Aggiungi parametro' | siaTranslate }}
        </button>
        @for (
          param of gridConfiguration.params;
          track param;
          let paramIndex = $index
        ) {
          <div class="surface-low flex flex-col gap-2 rounded-lg p-2">
            <div class="flex flex-row gap-2">
              <sia-select-box
                [(value)]="param.name"
                [disabled]="false"
                [selectBoxOptions]="{
                  value: param.name,
                  dbKey: 'web.V_SPParameters',
                  disableEmptyElement: true,
                  foreignKey: gridConfiguration.selectSpName,
                }"
                label="Campo della vista"
                class="!w-[calc(33.33%-.5rem)]"
              ></sia-select-box>
            </div>

            <sia-js-editor
              [(jsCode)]="param.script"
              [title]="'Script per valore'"
            ></sia-js-editor>
            <button
              mat-stroked-button
              (click)="removeSpParams(paramIndex)"
              class="error m-auto"
            >
              <mat-icon>delete</mat-icon>
              {{ 'Elimina Parametro' | siaTranslate }}
            </button>
          </div>
        }
      </div>
    </div>
  </sia-accordion>

  <sia-accordion title="Prefiltri" [opened]="true" style="width: 100%">
    <div class="flex flex-col gap-2">
      <button mat-button (click)="addPrefilter()" class="w-full">
        <mat-icon>add</mat-icon> {{ 'Aggiungi prefiltro' | siaTranslate }}
      </button>

      @for (
        filter of gridConfiguration.sqlPrefilters;
        track filter;
        let index = $index
      ) {
        <div class="surface-low flex flex-col gap-2 rounded-lg p-2">
          <sia-js-editor
            [(jsCode)]="filter.valueScript"
            [title]="'Script per valore sql' | siaTranslate"
          ></sia-js-editor>
          <button
            mat-stroked-button
            (click)="removePrefilter(index)"
            class="error m-auto"
          >
            <mat-icon>delete</mat-icon> {{ 'Elimina' | siaTranslate }}
          </button>
        </div>
      }
    </div>
  </sia-accordion>

  <sia-accordion title="Stile" [opened]="true" style="width: 100%">
    <div class="flex flex-col gap-2">
      <button mat-button (click)="addStyle()" class="w-full">
        <mat-icon>add</mat-icon> {{ 'Aggiungi stile' | siaTranslate }}
      </button>

      @for (
        style of gridConfiguration.rowStyleConditions;
        track style;
        let index = $index
      ) {
        <div class="surface-low flex flex-col gap-2 rounded-lg p-2">
          <sia-js-editor
            [(jsCode)]="style.cssStyleCondition"
            [title]="'Condizione'"
          ></sia-js-editor>
          <sia-css-editor
            [(cssCode)]="style.cssStyle"
            [title]="'Stile css'"
          ></sia-css-editor>
          <button
            mat-stroked-button
            (click)="removeStyle(index)"
            class="error m-auto"
          >
            <mat-icon>delete</mat-icon> {{ 'Elimina' | siaTranslate }}
          </button>
        </div>
      }
    </div>
  </sia-accordion>
</div>
